var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ActionSheetProvider } from '@expo/react-native-action-sheet';
import { Observable } from '../../../Data/Observable/Observable';
const hasActionSheetProvider = new Observable(false);
export function getHasActionSheetProvider() {
    return hasActionSheetProvider;
}
export function ActionSheetProviderView(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    useEffect(() => {
        hasActionSheetProvider.next(true);
        return () => {
            hasActionSheetProvider.next(false);
        };
    }, []);
    return _jsx(ActionSheetProvider, Object.assign({}, props, { children: children }));
}
